import { types, actions } from './requests'
export const DELETEWORKLIST_TYPES = {
    ...types('DELETEWORKLIST'),
}
export const DELETEWORKLIST_ACTIONS = {
    ...actions('DELETEWORKLIST'),
}
